<template>
  <div class="page-container">
    <div class="query-title">系统日志</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini" label-width="100px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="接口描述">
                    <el-input v-model="conditions.interDesc" placeholder="请输入" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="接口编码">
                    <el-select v-model="conditions.progCode" clearable>
                      <el-option v-for="item in codeTypes" :key="item.code" :value="item.code" :label="item.name" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="接口名称">
                    <el-input v-model="conditions.progName" placeholder="请输入" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="返回信息">
                    <el-input v-model="conditions.message" placeholder="请输入" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="数据内容">
                    <el-input v-model="conditions.body" placeholder="请输入" clearable />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="状态">
                    <el-select v-model="conditions.status" clearable>
                      <el-option v-for="item in statusTypes" :key="item.code" :value="item.code" :label="item.name" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData(1)">查询</el-button>
              <el-button size="mini" type="primary" @click="showRunningLog">运行日志</el-button>
              <el-button size="mini" type="primary" @click="dataToCenter">数据维护</el-button>
              <el-button size="mini" type="primary" @click="validateQtyInfo">校验发票</el-button>
              <el-button size="mini" type="primary" @click="showUserDialog = true">查询用户</el-button>
            </el-form>

          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="日志"
          :custome-config="() => vxeShowCustom('gridOptions')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <template #button>
            <table-button name="export" tip="导出全部" @click="exportPage" />
          </template>
          <vxe-grid
            ref="gridOptions"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            @cell-dblclick="editRow"
          />
        </TableCommon>
      </div>
    </div>

    <el-dialog :visible.sync="showUserDialog" width="70%" title="用户查询">
      <UserQuery />
    </el-dialog>

    <el-dialog :visible.sync="showInvoiceDialog" width="70%" title="检验发票结果">
      <el-input type="textarea" rows="25" readonly :value="invoiceResult" />
      <div class="invoiceResult" />
    </el-dialog>

    <el-dialog title="运行日志" :visible.sync="runningDialog" width="70%" fullscreen>
      <template v-if="runningDialog">
        <RunningLog />
      </template>
    </el-dialog>

    <el-dialog title="日志" :visible.sync="dialog" width="70%">
      <el-form inline size="small" label-width="120px">
        <el-row>
          <!--el-col-- :span="12">
            <el-form-item label="id">
              <el-input readonly :value="currentRow.id" />
            </el-form-item>
          </el-col-->
          <el-col :span="12">
            <el-form-item label="发生时间">
              <el-input readonly :value="currentRow.datum" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接口名称">
              <el-input readonly :value="currentRow.progName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接口编码">
              <el-input readonly :value="currentRow.progCode" />
            </el-form-item>
          </el-col>
          <!--el-col :span="12">
            <el-form-item label="接口描述">
              <el-input readonly :value="currentRow.interDesc" />
            </el-form-item>
          </el-col-->
          <el-col :span="12">
            <el-form-item label="状态">
              <el-input readonly :value="currentRow.status" />
            </el-form-item>
          </el-col>
          <!--el-col :span="12">
            <el-form-item label="操作人">
              <el-input readonly :value="currentRow.uname" />
            </el-form-item>
          </el-col-->
          <el-col :span="24">
            <!--el-form-item-- label="信息">
              <el-input readonly :value="currentRow.message" />
            </el-form-item-->
            <el-form-item label="返回信息" class="data-body">
              <el-input readonly rows="2" resize="none" style="width: 100%" type="textarea" :value="currentRow.message" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="数据内容" class="data-body">
              <el-input readonly rows="20" resize="none" style="width: 100%" type="textarea" :value="currentRow.body" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import JSONFormatter from 'json-formatter-js'
import { dataToCenter, validateQtyInfo } from '@/api/applyForGoods/index'
import { apiSystemlog } from '@/api/common'
import RunningLog from './components/RunningLog.vue'
import UserQuery from './components/userDialog.vue'
import { frontExport, concurrencyReq } from '@/utils/frontExport'

export default {
  components: { RunningLog, UserQuery },
  data() {
    return {
      conditions: {
        interDesc: '',
        progCode: '',
        progName: '',
        message: '',
        status: ''
      },
      codeTypes: [
        { 'name': '推送安吉', 'code': 'toAnji' },
        { 'name': '推送中台', 'code': 'toCenter' },
        { 'name': '推送OA', 'code': 'toOA' },
        { 'name': '取消要货申请', 'code': 'cancelWantGoods' },
        { 'name': '校验发票', 'code': 'checkInvoice' },
        { 'name': '安吉推送', 'code': 'fromAnji' },
        { 'name': '中台推送', 'code': 'fromCenterStage' },
        { 'name': '发票推送', 'code': 'fromCRM' },
        { 'name': '公关团购推送', 'code': 'fromGGTG' },
        { 'name': '批条酒推送', 'code': 'fromPTJ' },
        { 'name': 'Sap发票推送', 'code': 'fromSAPInvoice' },
        { 'name': '五商调用', 'code': 'fromWuShang' },
        { 'name': '新零售调用', 'code': 'fromXinLingShou' },
        { 'name': '推送新零售', 'code': 'toXls' },
        { 'name': '推送博智', 'code': 'toBoZhi' },
        { 'name': '取消草稿状态的要货申请', 'code': 'cancelApplyBill' },
        { 'name': '统计销售计划历史数据', 'code': 'countSalePlan' },
        { 'name': '推送ERP', 'code': 'toERP' }
      ],
      statusTypes: [
        { 'name': '成功', 'code': 'S' },
        { 'name': '失败', 'code': 'E' }
      ],
      dialog: false,
      showInvoiceDialog: false,
      runningDialog: false,
      showUserDialog: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      invoiceResult: null,
      gridOptions: {
        columns: [
          { title: 'id', field: 'id', width: 150, visible: false },
          { title: '时间', field: 'datum', width: 140 },
          { title: '接口描述', field: 'interDesc', width: 160 },
          { title: '返回信息', field: 'message', width: 320 },
          { title: '数据内容', field: 'body', width: 300 },
          { title: '接口编码', field: 'progCode', width: 90 },
         // { title: '接口名称', field: 'progName', width: 160 },
          { title: '状态', field: 'status', width: 60 },
          { title: '操作人', field: 'uname', width: 100 }
        ],
        data: []
      },
      currentRow: {}
    }
  },
  created() {
    this.queryData()
  },
  methods: {
    async queryData(page) {
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      page && (params.page = page)
      const res = await apiSystemlog(params)
      this.gridOptions.data = res.data.Rows
      this.pagination.totalCount = res.data.Total
    },
    // 重推中台
    async dataToCenter() {
      this.$confirm('是否真的要重传数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const params = {
          ...this.conditions
        }
        const { data } = await dataToCenter(({message: this.conditions.message, interDesc: this.conditions.interDesc }))
       // this.wantCode = wantCode
         if (data==""){
           this.$message.success('推送成功！')
         } else {
           this.$message.warning('推送失败：'+data)
         }
      })
    },
    // 校验发票
    async validateQtyInfo() {
      const { data } = await validateQtyInfo({ })
      // 保存对象字符串
      this.invoiceResult = JSON.stringify(data)
      this.showInvoiceDialog = true

      // json格式化样式
      const formatter = new JSONFormatter(data)
      this.$nextTick(() => {
        const dom = document.querySelector('.invoiceResult')
        dom.appendChild(formatter.render())
        formatter.openAtDepth(3)
      })
    },
    // 运行日志
    showRunningLog() {
      this.runningDialog = true
    },
    // 双击行
    editRow({ row }) {
      this.currentRow = row
      this.dialog = true
    },
    reset() {
      this.conditions = {
        interDesc: '',
        progCode: '',
        progName: '',
        message: ''
      }
    },
    async exportPage() {
      const params = {
        ...this.conditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiSystemlog)
      frontExport(this.gridOptions.columns, data, '系统日志')
    },
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input {
  width: 300px
}
.data-body {
  width: 100%;
  /deep/ .el-form-item__content{
    width: calc(100% - 120px) !important;
  }
}
.vxe-grid .vxe-table--body-wrapper.body--wrapper .vxe-body--row .vxe-body--column .vxe-cell{
    white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/client-manage/systemLog.vue